import Vue from 'vue'

//import plugins
import 'es6-promise/auto' //vuex need it too...
import store from './store'
import router from './plugins/router'
import vuetify from './plugins/vuetify';

if (process.env.VUE_APP_MODE === 'web') {
  require('./plugins/registerServiceWorker');
}

Vue.config.productionTip = false;


import rules from './utils/rules';

Vue.prototype.$rules = rules;

import config from './utils/config';

Vue.prototype.$config = config;

import helpers from './utils/helpers';

Vue.prototype.$helpers = helpers;

// global Mixin
import globalMixin from './mixins/global';

Vue.mixin(globalMixin);

import App from './App.vue'

new Vue({
  store,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app');